export var HttpErrorCode;
(function (HttpErrorCode) {
    HttpErrorCode[HttpErrorCode["UNKNOWN_ERROR"] = 500] = "UNKNOWN_ERROR";
    HttpErrorCode[HttpErrorCode["MISSING_PARAMETERS"] = 400] = "MISSING_PARAMETERS";
    HttpErrorCode[HttpErrorCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpErrorCode[HttpErrorCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HttpErrorCode[HttpErrorCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpErrorCode[HttpErrorCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
})(HttpErrorCode || (HttpErrorCode = {}));
